import type { ReactNode } from 'react';

interface ModeProviderProps {
  children: ReactNode;
}

export function ModeProvider({ children }: ModeProviderProps) {
  return <>{children}</>;
}

export function useModeAwareQueryKey(baseKey: string): string[] {
  return [baseKey];
}
